import "./style.css";
import { useLanguage } from "../../context/LanguageContext";

const certificateLinks = [
  {
    url: "https://verified.sertifier.com/en/verify/98318067446406",
    image: require("../../assets/images/certificates/alotech.png"),
  },
  {
    url: "https://verified.sertifier.com/en/verify/11715798439220",
    image: require("../../assets/images/certificates/akbank.png"),
  },
  {
    url: "https://certificates.techcareer.net/tr/verify/24840481487312?ref",
    image: require("../../assets/images/certificates/techcareer.png"),
  },
];

const Certificates = () => {
  const { t } = useLanguage();
  const items = t("certificates.items");

  return (
    <section id="certificates">
      <div className="row section-intro">
        <div className="col-twelve">
          <h5>{t("certificates.title")}</h5>
          <h1>{t("certificates.subtitle")}</h1>
        </div>
      </div>

      <div className="row">
        <div className="projects">
          {items.map((item, index) => (
            <div className="card" key={index}>
              <a
                href={certificateLinks[index].url}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="card-img"
                  src={certificateLinks[index].image}
                  alt="project"
                />
                <div className="card-content">
                  <h3 className="card-title">{item.title}</h3>
                  <p className="card-text">{item.description}</p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificates;
